<script>
import api from "@/axios";
import Loader from "../components/loader";
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
// import EnderecosTable from './enderecos-table.vue'
import appConfig from "@/app.config";
import {condicoesChart1, condicoesChart2 } from "../components/data-simulados";
import Swal from "sweetalert2";
import 'vue3-lottie/dist/style.css'
import exportFromJSON from "export-from-json"
import {Workbook} from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import DxButton from 'devextreme-vue/button';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations, DxHeaderFilter
} from 'devextreme-vue/data-grid';
import CustomStore from "devextreme/data/custom_store";
import {saveAs} from "file-saver-es";
import {helpers, required} from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Multiselect from "@vueform/multiselect";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Endereços",
    meta: [{ descricao: "description", content: appConfig.description }]
  },
  components: {
    DxHeaderFilter, Layout, PageHeader, Loader, DxDropDownButton,
    DxButton, DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxSelection, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Multiselect
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {

      title: 'Endereços',
      items: [
        {
          text: 'WMS',
          href: '/',
        },
        {
          text: 'Endereços',
          active: true,
        },
      ],
      errosValid: null,
      loadingList: true,
      loadingGraph: true,
      enderecosList: {
        type: Array,
        default: function () {
          return [];
        },
      },

      enderChart1: condicoesChart1,
      enderChart2: condicoesChart2,
      pesqTextFilter: '',
      statusFilterValue: 'T',
      statusFilter: [
        {value: 'T', text: 'Todos'},
        {value: 'A', text: 'Ativo'},
        {value: 'I', text: 'Inativo'},
      ],

      tipoCriacao: 'Off',

      regSelecionado: {},
      idData: null,
      empresaData: null,
      wmsEnderecoData: {
        // depto: 'P',
        // setor: 'A',
        area: 'PK',
        incr: null,
        noruaini: 'A',
        noruafim: 'C',
        nonumini: 1,
        nonumfim: 1,
        noandarini: 1,
        noandarfim: 1,
        noaptoini: 1,
        noaptofim: 1,
        comprimento: 120,
        altura: 150,
        largura: 100,
        empresa: null
      },
      showModal: false,
      showModalEditar: false,
      submitted: false,
      dataList: null,
      totalList: 0,
      rotaApi: null,
      dtListPesqEmpresa: []
    }
  },

  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },

  watch: {
    "regSelecionado.descricao"(newVal) {
      if (newVal) {
        const parts = newVal.split(".");
        if (parts.length >= 3) {
          this.regSelecionado.posx = parts[1].replace(/^0+/,"");
          this.regSelecionado.posy = parts[2].replace(/^0+/,"");
        } else {
          this.regSelecionado.posx = "";
          this.regSelecionado.posy = "";
        }
      }
    },
  },

  computed: {
    dataGrid: function () {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted enderecos-list_0')
    this.atualizaDataList()
  },

  methods: {
    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(JSON.stringify(res.data))

          this.dtListPesqEmpresa = res.data
        })
      }
    },

    tipoEndereco(e){
      switch(e.value){
        case 'padrao':
          return 'Padrão'

        case 'bloq':
          return 'Bloqueios'

        case 'reser':
          return 'Reservas'

        case 'falta':
          return 'Faltas/Avarias'

        case 'prev':
          return 'Entrada'

        case 'avar':
          return 'Avaria'
      }
    },

    estoque3D(){
      console.log('estoque3D')

      const routeData = this.$router.resolve(`/enderecos/3d`)
      window.open(routeData.href, '_blank')
    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true
      if (this.regSelecionado.descricao || this.wmsEnderecoData) {
        this.showModalEditar = false
        this.showModal = false
        this.loadingList = true
        this.errosValid = []

        if(this.tipoCriacao === 'Off'){
          //criação individual
          this.rotaApi = 'wmsend'
          this.regSelecionado.empresa = this.wmsEnderecoData.empresa
          this.regSelecionado.area = this.wmsEnderecoData.area

        } else if(this.tipoCriacao === 'On'){
          //criação em massa
          this.rotaApi = 'wmsendgera'
          this.regSelecionado = this.wmsEnderecoData
        }

        console.log(this.regSelecionado)
        api.post(`${getBaseUrl()}api/${this.rotaApi}`, {
          wmsenddata: this.regSelecionado
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.loadingList = false
          if (res.data.success) {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
            timer: 1500
            })

            this.atualizaDataList()
          } else {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.message,
              showConfirmButton: false,
            timer: 1500
            })
          }
        })
      }
    },

    estoqueEndereco(){
      console.log('estoqueEndereco')

      const routeData = this.$router.resolve(`/produtos/listestoqender`)
      window.open(routeData.href, '_blank')


    },


    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          this.updating = true
          api.delete(`${getBaseUrl()}api/wmsend`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            // console.log('then axios delete')
            // console.log(res.data)

            if(res.data === 'exclusao_realizada_com_sucesso') {

              this.showModalEditar = false
              this.atualizaDataList()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "O endereço não pode ser excluído, pois existem produtos vinculados a ele!",
                showConfirmButton: false,
                timer: 1800
              })
            }
          })
        }
      })
    },

    criarNova() {
      console.log('criarNova')
      //this.$refs.childTable.setCriarNova(true)

      this.regSelecionado.id = null;
      this.regSelecionado.descricao = null;
      this.regSelecionado.codigo = null;
      this.regSelecionado.status = 'A';
      this.regSelecionado.comprimento = 120;
      this.regSelecionado.altura = 150;
      this.regSelecionado.largura = 100;
      this.regSelecionado.posx = null;
      this.regSelecionado.posy = null;
      this.regSelecionado.tipoender = 'padrao';

      this.showModal = true

    },

    exportExcel(){
      console.log('exportExcel')
      const data = this.dataList
      const fileName = "exp_dados";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    carregouGrid(e) {
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ") Endereços"
    },

    atualizaDataList(){
      this.loadingList = true

      this.dataList = new CustomStore({
        key: "id",
        load: (loadOptions) => {
          let queryArray = [];
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }

          const s = this.statusFilterValue
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
            's': s
          }

          return api.get(`${getBaseUrl()}api/enderecos`, {
            params: paramsReq
          }).then(res => {
            console.log('then axios')
            console.log(res)
            return {
              data: res.data[0],
              totalCount: res.data[1]
            }
          }).catch((e) => {
            console.log('error Endereço List')
            console.log(e)
          })
        },
      })

      this.loadingList = false
      this.loadingGraph = false

    },

    onRowDblClick(row) {
      console.log('onRowDblClick')

      let idData = row.data.id
      const dataRow = row.data

      this.idData = idData
      this.regSelecionado = dataRow

      if (this.regSelecionado) {
        // console.log('regSelecionado: ', this.regSelecionado)
        this.showModalEditar = true

      }else {
        console.error('A tabela de endereços não está disponível ou está vazia.');
      }
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.mov_status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'EL':
              corStatus = 'rgba(78,59,0,0.5)'
              break
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },

    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    onFilterClick(e){
      const filteredValue = e.itemData.value;
      this.statusFilterValue = filteredValue;

      this.atualizaDataList();
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);
    },

    nomeStatus(e) {
      switch (e.value) {
        case 'A':
          return 'Ativo'
        case 'I':
          return 'Inativo'
      }

      return 'Não Definido'
    },

    deletouReg(dataID){
      console.log('deletouReg_pai dataid:')
      console.log(dataID)

      this.loadingList = true
      api.delete(`${getBaseUrl()}api/endereco`, {
        params: {
          'iddata': dataID
        }
      }).then((res) => {
        console.log('then axios delete')
        console.log(res.data)
        this.atualizaDataList()
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações excluídas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })
    },

    alterouReg(regSelecionado) {
      console.log('alterouReg_pai')
      console.log(regSelecionado)
      this.loadingList = true

      this.errosValid = []
      api.post(`${getBaseUrl()}api/endereco`, {
        enderecoData: regSelecionado
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.produtoData = res.data[0]
        // this.loadingList = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.atualizaDataList()

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.loadingList = false
      })
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2 });
      }
      return 0.00;
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 0 });
      }
      return 0.00;
    }
  },
}
</script>

<template>

  <Layout>

    <PageHeader :title="title" :items="items" />

    <div>
      <DxToolbar>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">

          <DxDropDownButton
              v-model="statusFilterValue"
              :items="statusFilter"
              :drop-down-options="{ width: 150 }"
              icon="filter"
              show-arrow="false"
              hint="Filtrar Status"
              display-expr="text"
              value-expr="value"
              @item-click="onFilterClick"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Novo Endereço"
              text="Novo Endereço"
              :on-click="criarNova"/>
        </DxItem>
        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="box"
              hint="Estoque 3D"
              text="Estoque 3D"
              :disabled="true"
              :on-click="estoque3D"/>
        </DxItem>

      </DxToolbar>
    </div>

    <Loader v-if="loadingList" style="min-height: 300px;">
    </Loader>

    <div class="mt-2" v-if="!loadingList">
      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Validação de campo: <strong>{{ erro.titulo }}</strong> | <strong>{{ erro.mensagem[0] }}</strong>.
        favor ajustar e tentar novamente!
      </b-alert>

      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @content-ready="carregouGrid"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />

        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />
        <DxHeaderFilter :visible="true" />

        <DxSelection mode="multiple"/>
        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strDocCobList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            :width="110"
            data-field="id"
            caption="ID"
            sort-order="desc"
            data-type="number"
            alignment="center"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="codigo"
            caption="Código"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="descricao"
            caption="Descrição"
            data-type="text"
            alignment="center"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="comprimento"
            caption="Comprimento"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="altura"
            caption="Altura"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="largura"
            caption="Largura"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="posx"
            caption="Posição X"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="posy"
            caption="Posição Y"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="created_at"
            caption="Data"
            data-type="datetime"
            alignment="center"
            format="dd/MM/yyyy"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="110"
            data-field="status"
            caption="Status"
            data-type="text"
            alignment="center"
            :customize-text="nomeStatus"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            :width="110"
            data-field="tipoender"
            caption="Tipo"
            data-type="text"
            alignment="center"
            :customize-text="tipoEndereco"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>

      </DxDataGrid>

    </div>


<!--    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">

              <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        placeholder="Enter para pesquisar..."
                        @change="atualizaDataList"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-sm-1">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <select
                        id="selectStatus"
                        v-model="statusFilter"
                        @change="atualizaDataList"
                        class="form-control select2-search-disable">
                      <option value="T" selected>Todos</option>
                      <option value="A">Ativos</option>
                      <option value="I">Inativos</option>
                    </select>
                    <i class="bx bx-filter-alt search-icon"></i>
                  </div>
                </div>
              </div>


              <div class="col-sm-2">
                <div class="mb-2 d-inline-block">
                  <div class="position-relative">
                    <b-button variant="outline-primary" class="" @click="exportExcel">
                      <i class="bx bx-export font-size-16 align-middle "></i>
                    </b-button>
                  </div>
                </div>
              </div>

              <div class="col-sm-7">
                <div class="text-sm-end">

&lt;!&ndash;                  <router-link :to="`/endereco/editar/0`">&ndash;&gt;
&lt;!&ndash;                    <button type="button" class="btn btn-success btn-rounded mb-2 me-2" >&ndash;&gt;
&lt;!&ndash;                      <i class="mdi mdi-plus me-1"></i> Novo Endereço&ndash;&gt;
&lt;!&ndash;                    </button>&ndash;&gt;
&lt;!&ndash;                  </router-link>&ndash;&gt;
                  <button type="button" class="btn btn-success btn-rounded mb-2 me-2" @click="criarNova">
                    <i class="mdi mdi-plus me-1"></i> Novo Endereço
                  </button>

                </div>
              </div>
            </div>

            <Loader v-if="loadingList" style="min-height: 300px;">
            </Loader>

            <EnderecosTable v-if="!loadingList"
                           ref="childTable"
                           :enderecosList="enderecosTable"
                           @deletareg="deletouReg"
                           @alterareg="alterouReg"/>

            <ul class="pagination pagination-rounded justify-content-end mb-2">
              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Previous">
                  <i class="mdi mdi-chevron-left"></i>
                </a>
              </li>
              <li class="page-item active">
                <a class="page-link" href="javascript: void(0);">1</a>
              </li>

              <li class="page-item disabled">
                <a class="page-link" href="javascript: void(0);" aria-label="Next">
                  <i class="mdi mdi-chevron-right"></i>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>-->

    <b-modal :title="regSelecionado.id != null ? `Editar Endereço (${ regSelecionado.id })` : 'Criar Novo Endereço'"
             size="xl"
             v-model="showModalEditar" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-6">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição (Ex.: A.001.1.1)"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>

            </div>
          </div>

          <div class="col-md-2">
            <label for="comprimento">Comprimento</label>
            <div class="position-relative">
              <input id="comprimento"
                     type="number"
                     v-model="regSelecionado.comprimento"
                     class="form-control text-end"
                     placeholder="Comprimento (cm.)" />
            </div>
          </div>

          <div class="col-md-2">
            <label for="altura">Altura</label>
            <div class="position-relative">
              <input id="altura"
                     type="number"
                     v-model="regSelecionado.altura"
                     class="form-control text-end"
                     placeholder="Altura (cm.)" />
            </div>
          </div>

          <div class="col-md-2">
            <label for="largura">Largura</label>
            <div class="position-relative">
              <input id="largura"
                     type="number"
                     v-model="regSelecionado.largura"
                     class="form-control text-end"
                     placeholder="Largura (cm.)" />
            </div>
          </div>

          <div class="col-md-2">
            <label for="posx">Posição X</label>
            <div class="position-relative">
              <input id="posx"
                     type="number"
                     v-model="regSelecionado.posx"
                     class="form-control text-end"
                     placeholder="Posição X" />
            </div>
          </div>

          <div class="col-md-2">
            <label for="posy">Posição Y</label>
            <div class="position-relative">
              <input id="posy"
                     type="number"
                     v-model="regSelecionado.posy"
                     class="form-control text-end"
                     placeholder="Posição Y" />
            </div>
          </div>

        </div>


        <div class="d-flex justify-content-sm-between mt-5">
            <b-button variant="outline-danger" class="ms-1" @click="deletar(regSelecionado.id)">
              <i class="mdi mdi-trash-can font-size-16 align-middle me-2"></i>
              Deletar
            </b-button>

            <b-button variant="outline-info" class="ms-1" @click="estoqueEndereco">
              <i class="bx bx-box font-size-16 align-middle me-2"></i>
              Estoque
            </b-button>

            <b-button variant="success" class=" ms-1" @click="formSubmit">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
        </div>

      </form>

    </b-modal>

    <b-modal :title="tipoCriacao === 'Off' ? 'Criar Novo Endereço ( Individual )' : 'Criar Novo Endereço ( Em Massa )'"
             size="xl" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">
          <div class="col-12">
            <div class="float-start" style="width: 140px;">
              <h5 class="font-size-14" >Criação em Massa</h5>
              <div class="d-flex align-items-center justify-content-between" style="margin-top: -12px">
                <b-form-checkbox
                    switch
                    size="lg"
                    value="On"
                    unchecked-value="Off"
                    v-model="tipoCriacao">
                  {{ tipoCriacao === 'On' ? 'On' : 'Off' }}
                </b-form-checkbox>
              </div>
            </div>

            <div class="float-end" v-if="tipoCriacao === 'On'" style="width: 140px;">
              <h5 class="font-size-14">End. Sem Paletes</h5>
              <div class="d-flex align-items-center justify-content-between"  style="margin-top: -12px">
                <b-form-checkbox
                    switch size="lg"
                    value="S"
                    unchecked-value="N"
                    v-model="wmsEnderecoData.endsempal">
                  {{ wmsEnderecoData.endsempal === 'S' ? 'Sim' : 'Não' }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          <div class="col-6">
            <label for="empresaProd">Empresa</label>
            <multiselect
                id="empresaProd"
                @search-change="pesqEmpresa"
                v-model="wmsEnderecoData.empresa"
                placeholder="Selecionar Empresa"
                :options="dtListPesqEmpresa"
                :searchable="true"
                track-by="codigo"
                label="nome"
                value-prop="codigo"
            >
              <template #option="slotProps">
                <div class="row">
                  <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>

                    <span class="mx-4" >
                  </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <span class="mx-4">
                  </span>

                  <span class="mx-4" >
                  </span>
                  <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div class="col-6" v-if="tipoCriacao === 'Off'">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição (Ex.: A.001.1.1)"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                  <span v-if="v$.regSelecionado.descricao.required.$message">
                    {{ v$.regSelecionado.descricao.required.$message }}
                  </span>
              </div>
            </div>
          </div>

          <div class="row col-6" v-else-if="tipoCriacao === 'On'">
            <div class="col-sm-4" v-if="empresaData && empresaData.wmsigdepto !== 'A'">
              <div class="mb-3">
                <label for="depto">Departamento</label>
                <select
                    id="depto"
                    v-model="wmsEnderecoData.depto"
                    class="form-control">
                  <option value="P">Depósito Geral</option>
                  <option value="O">Outro</option>
                </select>
              </div>
            </div>

            <div class="col-sm-4" v-if="empresaData && empresaData.wmsigdepto !== 'A'">
              <div class="mb-3">
                <label for="setor">Nome Setor</label>
                <select
                    id="setor"
                    v-model="wmsEnderecoData.setor"
                    class="form-control">
                  <option value="A">Armazenagem</option>
                  <option value="O">Outro</option>
                </select>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="area">Área</label>
                <select
                    id="area"
                    v-model="wmsEnderecoData.area"
                    class="form-control">
                  <option value="PK">Picking</option>
                  <option value="PU">Pulmão</option>
                </select>
              </div>
            </div>
          </div>


          <div class="col-6" v-if="tipoCriacao === 'Off'">
            <div class="mb-3">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="row" v-else-if="tipoCriacao === 'On'">
            <div class="col-sm-4">
              <div class="mb-3">
                <label for="incr">Incremento</label>
                <input
                    id="incr"
                    v-model="wmsEnderecoData.incr"
                    type="number"
                    class="form-control"
                    placeholder="Incremento"/>
              </div>
            </div>

            <div class="col-4">
              <div class="mb-3">
                <label for="noruaini">Rua Inicial</label>
                <input
                    id="noruaini"
                    v-model="wmsEnderecoData.noruaini"
                    type="text"
                    maxlength="1"
                    class="form-control"
                    placeholder="Inserir rua inicial"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noruaini,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noruaini"
                    class="invalid-feedback">
                <span>
                  Campo rua inicial obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="mb-3">
                <label for="noruafim">Rua Final</label>
                <input
                    id="noruafim"
                    v-model="wmsEnderecoData.noruafim"
                    type="text"
                    maxlength="1"
                    class="form-control"
                    placeholder="Inserir rua final"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noruafim,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noruafim"
                    class="invalid-feedback">
                <span>
                  Campo rua final obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6" v-if="tipoCriacao === 'Off'">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="row" v-else-if="tipoCriacao === 'On'">
            <div class="col-2">
              <label for="comprimento">Comprimento</label>
              <div class="position-relative">
                <input id="comprimento"
                       type="number"
                       v-model="wmsEnderecoData.comprimento"
                       class="form-control text-end"
                       placeholder="Comprimento (cm.)" />
              </div>
            </div>

            <div class="col-4 ms-auto">
              <div class="mb-3">
                <label for="nonumini">Número Inicial</label>
                <input
                    id="nonumini"
                    v-model="wmsEnderecoData.nonumini"
                    type="number"
                    class="form-control"
                    placeholder="Inserir número inicial"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.nonumini,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.nonumini"
                    class="invalid-feedback">
                <span>
                  Campo número inicial obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="mb-3">
                <label for="nonumfim">Número Final</label>
                <input
                    id="nonumfim"
                    v-model="wmsEnderecoData.nonumfim"
                    type="number"
                    class="form-control"
                    placeholder="Inserir número final"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.nonumfim,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.nonumfim"
                    class="invalid-feedback">
                <span>
                  Campo número final obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-2" v-if="tipoCriacao === 'Off'">
            <label for="comprimento">Comprimento</label>
            <div class="position-relative">
              <input id="comprimento"
                     type="number"
                     v-model="regSelecionado.comprimento"
                     class="form-control text-end"
                     placeholder="Comprimento (cm.)" />
            </div>
          </div>

          <div class="row" v-else-if="tipoCriacao === 'On'">
            <div class="col-2 ">
              <label for="altura">Altura</label>
              <div class="position-relative">
                <input id="altura"
                       type="number"
                       v-model="wmsEnderecoData.altura"
                       class="form-control text-end"
                       placeholder="Altura (cm.)" />
              </div>
            </div>

            <div class="col-4 ms-auto">
              <div class="mb-3">
                <label for="noandarini">Andar</label>
                <input
                    id="noandarini"
                    v-model="wmsEnderecoData.noandarini"
                    type="number"
                    class="form-control"
                    placeholder="Inserir número inicial"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noandarini,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noandarini"
                    class="invalid-feedback">
                <span>
                  Campo andar inicial obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="mb-3">
                <label for="noandarfim">Andar Final</label>
                <input
                    id="noandarfim"
                    v-model="wmsEnderecoData.noandarfim"
                    type="number"
                    class="form-control"
                    placeholder="Inserir andar final"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noandarfim,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noandarfim"
                    class="invalid-feedback">
                <span>
                  Campo andar final obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-2" v-if="tipoCriacao === 'Off'">
            <label for="altura">Altura</label>
            <div class="position-relative">
              <input id="altura"
                     type="number"
                     v-model="regSelecionado.altura"
                     class="form-control text-end"
                     placeholder="Altura (cm.)" />
            </div>
          </div>

          <div class="row" v-else-if="tipoCriacao === 'On'">
            <div class="col-2">
              <label for="largura">Largura</label>
              <div class="position-relative">
                <input id="largura"
                       type="number"
                       v-model="wmsEnderecoData.largura"
                       class="form-control text-end"
                       placeholder="Largura (cm.)" />
              </div>
            </div>

            <div class="col-4 ms-auto">
              <div class="mb-3">
                <label for="noaptoini">Apto. Inicial</label>
                <input
                    id="noaptoini"
                    v-model="wmsEnderecoData.noaptoini"
                    type="number"
                    class="form-control"
                    placeholder="Inserir apto. inicial"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noaptoini,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noaptoini"
                    class="invalid-feedback">
                <span>
                  Campo apto. inicial obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="mb-3">
                <label for="noaptofim">Apto. Final</label>
                <input
                    id="noaptofim"
                    v-model="wmsEnderecoData.noaptofim"
                    type="number"
                    class="form-control"
                    placeholder="Inserir apto. final"
                    :class="{'is-invalid': submitted && !wmsEnderecoData.noaptofim,}"/>
                <div
                    v-if="submitted && !wmsEnderecoData.noaptofim"
                    class="invalid-feedback">
                <span>
                  Campo apto. final obrigatório, favor preencher.
                </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-2" v-if="tipoCriacao === 'Off'">
            <label for="largura">Largura</label>
            <div class="position-relative">
              <input id="largura"
                     type="number"
                     v-model="regSelecionado.largura"
                     class="form-control text-end"
                     placeholder="Largura (cm.)" />
            </div>
          </div>

          <div class="col-md-2" v-if="tipoCriacao === 'Off'">
            <label for="posx">Posição X</label>
            <div class="position-relative">
              <input id="posx"
                     type="text"
                     v-model="regSelecionado.posx"
                     class="form-control text-end"
                     placeholder="Posição X" />
            </div>
          </div>

          <div class="col-md-2" v-if="tipoCriacao === 'Off'">
            <label for="posy">Posição Y</label>
            <div class="position-relative">
              <input id="posy"
                     type="text"
                     v-model="regSelecionado.posy"
                     class="form-control text-end"
                     placeholder="Posição Y" />
            </div>
          </div>

            <div class="col-md-2" v-if="tipoCriacao === 'Off'">
              <label for="tipoender">Tipo</label>
              <div class="position-relative">
                <select class="form-control" v-model="regSelecionado.tipoender" id="tipoender">
                  <option value="padrao">Padrão</option>
                  <option value="prev">Entrada</option>
                </select>
              </div>
            </div>
        </div>

        <div class="text-end mt-3" >
          <b-button variant="outline-danger" class="ms-1" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Gerar
          </b-button>
        </div>
      </form>
    </b-modal>

<!--    <b-modal size="lg" :title="'Gerar Novos Locais de Armazenagem'" v-model="showModal1" hide-footer>


      <form @submit.prevent="formSubmit">
        <div class="row">
          <div class="col-sm-4" v-if="empresaData && empresaData.wmsigdepto !== 'A'">
            <div class="mb-3">
              <label for="depto">Departamento</label>
              <select
                  id="depto"
                  v-model="wmsEnderecoData.depto"
                  class="form-control">
                <option value="P">Depósito Geral</option>
                <option value="O">Outro</option>
              </select>
            </div>
          </div>

          <div class="col-sm-4" v-if="empresaData && empresaData.wmsigdepto !== 'A'">
            <div class="mb-3">
              <label for="setor">Nome Setor</label>
              <select
                  id="setor"
                  v-model="wmsEnderecoData.setor"
                  class="form-control">
                <option value="A">Armazenagem</option>
                <option value="O">Outro</option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="mb-3">
              <label for="area">Área</label>
              <select
                  id="area"
                  v-model="wmsEnderecoData.area"
                  class="form-control">
                <option value="PK">Picking</option>
                <option value="PU">Pulmão</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="mb-3">
              <label for="incr">Incremento</label>
              <input
                  id="incr"
                  v-model="wmsEnderecoData.incr"
                  type="number"
                  class="form-control"
                  placeholder="Incremento"/>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="noruaini">Rua Inicial</label>
              <input
                  id="noruaini"
                  v-model="wmsEnderecoData.noruaini"
                  type="text"
                  maxlength="1"
                  class="form-control"
                  placeholder="Inserir rua inicial"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noruaini,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noruaini"
                  class="invalid-feedback">
                <span>
                  Campo rua inicial obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="noruafim">Rua Final</label>
              <input
                  id="noruafim"
                  v-model="wmsEnderecoData.noruafim"
                  type="text"
                  maxlength="1"
                  class="form-control"
                  placeholder="Inserir rua final"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noruafim,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noruafim"
                  class="invalid-feedback">
                <span>
                  Campo rua final obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-sm-4">

          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="nonumini">Número Inicial</label>
              <input
                  id="nonumini"
                  v-model="wmsEnderecoData.nonumini"
                  type="number"
                  class="form-control"
                  placeholder="Inserir número inicial"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.nonumini,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.nonumini"
                  class="invalid-feedback">
                <span>
                  Campo número inicial obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="nonumfim">Número Final</label>
              <input
                  id="nonumfim"
                  v-model="wmsEnderecoData.nonumfim"
                  type="number"
                  class="form-control"
                  placeholder="Inserir número final"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.nonumfim,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.nonumfim"
                  class="invalid-feedback">
                <span>
                  Campo número final obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-sm-4">
&lt;!&ndash;            <div class="mb-3">&ndash;&gt;
&lt;!&ndash;              <h5 class="font-size-14">Endereços Sem Paletes</h5>&ndash;&gt;
&lt;!&ndash;              <b-form-checkbox&ndash;&gt;
&lt;!&ndash;                  switch size="lg"&ndash;&gt;
&lt;!&ndash;                  value="S"&ndash;&gt;
&lt;!&ndash;                  unchecked-value="N"&ndash;&gt;
&lt;!&ndash;                  v-model="wmsEnderecoData.endsempal">&ndash;&gt;
&lt;!&ndash;                {{ wmsEnderecoData.endsempal === 'S' ? 'Sim' : 'Não' }}&ndash;&gt;
&lt;!&ndash;              </b-form-checkbox>&ndash;&gt;
&lt;!&ndash;            </div>&ndash;&gt;
          </div>


          <div class="col-4">
            <div class="mb-3">
              <label for="noandarini">Andar</label>
              <input
                  id="noandarini"
                  v-model="wmsEnderecoData.noandarini"
                  type="number"
                  class="form-control"
                  placeholder="Inserir número inicial"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noandarini,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noandarini"
                  class="invalid-feedback">
                <span>
                  Campo andar inicial obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="noandarfim">Andar Final</label>
              <input
                  id="noandarfim"
                  v-model="wmsEnderecoData.noandarfim"
                  type="number"
                  class="form-control"
                  placeholder="Inserir andar final"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noandarfim,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noandarfim"
                  class="invalid-feedback">
                <span>
                  Campo andar final obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-sm-4">
            <div class="mb-3">
              <h5 class="font-size-14">Endereços Sem Paletes</h5>
              <b-form-checkbox
                  switch size="lg"
                  value="S"
                  unchecked-value="N"
                  v-model="wmsEnderecoData.endsempal">
                {{ wmsEnderecoData.endsempal === 'S' ? 'Sim' : 'Não' }}
              </b-form-checkbox>
            </div>
          </div>


          <div class="col-4">
            <div class="mb-3">
              <label for="noaptoini">Apto. Inicial</label>
              <input
                  id="noaptoini"
                  v-model="wmsEnderecoData.noaptoini"
                  type="number"
                  class="form-control"
                  placeholder="Inserir apto. inicial"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noaptoini,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noaptoini"
                  class="invalid-feedback">
                <span>
                  Campo apto. inicial obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

          <div class="col-4">
            <div class="mb-3">
              <label for="noaptofim">Apto. Final</label>
              <input
                  id="noaptofim"
                  v-model="wmsEnderecoData.noaptofim"
                  type="number"
                  class="form-control"
                  placeholder="Inserir apto. final"
                  :class="{'is-invalid': submitted && !wmsEnderecoData.noaptofim,}"/>
              <div
                  v-if="submitted && !wmsEnderecoData.noaptofim"
                  class="invalid-feedback">
                <span>
                  Campo apto. final obrigatório, favor preencher.
                </span>
              </div>
            </div>
          </div>

        </div>


        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Gerar
          </b-button>
        </div>

      </form>

    </b-modal>-->
    <Loader v-if="loadingGraph" style="min-height: 300px;">
    </Loader>



  </Layout>
</template>
